import { useQuery } from '@biletiniz/apollo';
import { DUBAI_VISA_BOOKING_INFO_QUERY } from './gql';

export const useDubaiVisaBookingInfo = ({ session }) => {
  const dubaiVisaBookingInfo = useQuery(DUBAI_VISA_BOOKING_INFO_QUERY, {
    variables: {
      session,
    },
    fetchPolicy: 'no-cache',
    skip: !session,
  });
  return {
    dubaiVisaBookingInfo: dubaiVisaBookingInfo?.data?.dubaiVisaBookingInfo,
    loadDubaiVisaBookingInfoError: dubaiVisaBookingInfo?.error?.message,
    isLoadingDubaiVisaBookingInfo: dubaiVisaBookingInfo.loading,
  };
};
